export default __webpack_public_path__ + "static/media/fa-regular-400.f3187c74.svg";